import { ovverideToAllowAllSystemPermissionInDev } from '@/authConfig';
import { onPermissionDenied } from '@/http/OpenAPI/clients/staleClaimRetry';
import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { Permission } from '../../http/CompanyUserManagement/Messages/Permission';
import PermissionClassification from '../enums/PermissionClassification';
import queryKeys from './queries/queryKeys';
import useUserPermissions from './queries/useUserPermissions';

const allowFullAccess = ovverideToAllowAllSystemPermissionInDev;

const useAllowedPermission = () => {
  const { data: allowedUserPermission = [] as Array<Permission>, isLoading } =
    useUserPermissions();
  const queryClient = useQueryClient();

  // ADO #7699: this list comes from the LIVE database, while the API gates on the
  // `extension_permissions` token claim, which is frozen at sign-in. A hard denial means the
  // two disagree, so refetch rather than keep serving a list up to 5 minutes old. That hides
  // a REVOKED permission; it deliberately does not hide the #7699 case, where the database
  // really does grant the permission and the remedy is the re-auth the error message asks for.
  useEffect(
    () =>
      onPermissionDenied(() => {
        void queryClient.invalidateQueries({ queryKey: [queryKeys.userPermissions] });
      }),
    [queryClient]
  );

  const userPermissionList = allowedUserPermission.map((x) => x.classification);

  const handleHasPermissionCheckFunction = (permission: PermissionClassification) => {
    return allowFullAccess || userPermissionList.includes(permission);
  };

  return {
    handleHasPermissionCheckFunction,
    isLoading
  };
};

export default useAllowedPermission;
